import config from '@/config';
import { LogicContext } from '@/logic/main/types';
import models from '@/model';

export const fetchBonusPermission = (context: LogicContext) => async () => {
  const authToken = context.user?.authToken?.access_token;

  const jurisdiction = config.jurisdiction;

  if (jurisdiction && authToken) {
    const { status, data } = await models.fetchBonusPermission({
      authToken,
      jurisdiction,
    });

    return {
      status,
      data,
    };
  }

  console.error(
    'There was a problem while fetching Bonus Permission data. Undefined jurisdiction or authToken.'
  );
  return {
    status: 400,
    data: {},
  };
};
